import { render, staticRenderFns } from "./ExamGuide.vue?vue&type=template&id=993a6844"
import script from "./ExamGuide.vue?vue&type=script&lang=js"
export * from "./ExamGuide.vue?vue&type=script&lang=js"
import style0 from "./ExamGuide.vue?vue&type=style&index=0&id=993a6844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports